import { SiteNav, SiteFooter } from "@/pages/LandingPage";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="privacy-policy-page">
      <SiteNav />
      <main className="pt-16">
        <section className="py-20 px-6 bg-white">
          <div className="max-w-3xl mx-auto prose prose-slate prose-sm">
            <p className="text-xs tracking-[0.2em] uppercase font-semibold text-ix-red-600 mb-3 not-prose">Legal</p>
            <h1 className="text-3xl font-bold text-ix-black tracking-tight">Privacy Policy</h1>
            <p className="text-xs text-slate-400">Last updated: April 2026</p>

            <h2 className="text-lg font-semibold text-ix-black mt-8">1. Information We Collect</h2>
            <p className="text-sm text-slate-600 leading-relaxed">We collect information you provide directly, including name, email address, organization details, compliance documents, and CSR budget information. We also collect usage data automatically through cookies and analytics.</p>

            <h2 className="text-lg font-semibold text-ix-black mt-6">2. How We Use Your Information</h2>
            <p className="text-sm text-slate-600 leading-relaxed">Your data is used to operate and improve the ImpactX Bridge platform, facilitate CSR-NGO matchmaking, verify compliance documentation, generate reports, and communicate platform updates.</p>

            <h2 className="text-lg font-semibold text-ix-black mt-6">3. Data Security</h2>
            <p className="text-sm text-slate-600 leading-relaxed">We implement industry-standard security measures including encrypted data transmission (TLS/SSL), secure document storage, role-based access controls, and regular security audits to protect your information.</p>

            <h2 className="text-lg font-semibold text-ix-black mt-6">4. Data Sharing</h2>
            <p className="text-sm text-slate-600 leading-relaxed">We do not sell personal information. Data is shared only as necessary to facilitate matches between CSR teams and NGOs on the platform, with your consent, or as required by Indian law.</p>

            <h2 className="text-lg font-semibold text-ix-black mt-6">5. Your Rights</h2>
            <p className="text-sm text-slate-600 leading-relaxed">You may request access, correction, or deletion of your personal data by contacting connect@impactxbridge.com. We comply with applicable Indian data protection regulations.</p>

            <h2 className="text-lg font-semibold text-ix-black mt-6">6. Contact</h2>
            <p className="text-sm text-slate-600 leading-relaxed">For questions about this policy, contact us at connect@impactxbridge.com or write to ImpactX Bridge Pvt Ltd, Kerala, India.</p>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}
